<script>
  import { Carousel3d, Slide } from 'vue-carousel-3d'
  import flatCarouselItem from './flat-carousel-item.vue'

  export default {
    name: 'coverFlowCarousel',
    components: {
      Carousel3d,
      flatCarouselItem,
      Slide
    },
    props: {
      itemList: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      activeItem: 0
    }),
    computed: {
      height() {
        const audioKeywords = ['audio book', 'music cd']
        const isAudio = audioKeywords.includes(this.itemList.category.toLowerCase())
        return isAudio ? 150 : 214
        // return this.itemList.category === 'CDs' ? 190 : 260
      },
      width() {
        return 150
      }
    },
    methods: {
      imageFix(img = '') {
        //configure fallback image
        return img.replaceAll('Type=S', 'Type=M')
      },
      onSlideChange(e) {
        this.activeItem = e
        this.$emit('active-item', {
          category: this.itemList.category,
          item: this.itemList.items[e]
        })
      }
    }
  }
</script>
<template>
  <carousel-3d :width="width" :height="height" class="carousel" @after-slide-change="onSlideChange">
    <slide v-for="(slide, i) in itemList.items" :index="i" :key="i">
      <!-- <figure> -->
      <!-- <img :src="imageFix(slide.imageLinks.thumbnail)" style="object-fit: cover; height: 100%; width: 100%" /> -->
      <flat-carousel-item :allowHover="activeItem === i" :height="`height`" :item="slide" :src="imageFix(slide.imageLinks.thumbnail)"></flat-carousel-item>
    </slide>
  </carousel-3d>
</template>

<style>
  .carousel-3d-container {
    overflow: hidden;
    margin: 0;
  }
  .carousel-3d-container figcaption {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    bottom: 1;
    height: 20%;
    position: absolute;
    bottom: 2px;
    padding: 1px;
    font-size: 0.75rem;
    min-width: 100%;
    box-sizing: border-box;
  }

  .carousel-3d-slide {
    background-color: #fff !important;
    background-image: url('https://media.eipl.org/site/images/logos/eipl-square.jpg') !important;
    background-position: center !important;
    background-size: 50% !important;
    border-radius: 8px !important;
    border-color: rgba(0, 0, 0, 0.4) !important;
    border-color: var(--v-primary-base) !important;
    border-style: solid !important;
    /* background-size: cover; */
    cursor: pointer !important;
    object-fit: cover !important;
    /* background-color: #ccc; */
    display: block !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    text-align: left !important;
    overflow: hidden !important;
  }
</style>
